<div *ngIf="!mobile && selectedObservation"
  class="observation-container">
  <div class="observation-identifier">
    {{ 'task.observations.observations' | blah }} {{ selectedObservation.orderNumber }}:
    <div *ngIf="selectedObservation.Type">
      {{ 'satnet.observationTypes.' + selectedObservation.Type | blah }}
    </div>
  </div>
  <div class="observation-interpreted">
    <hpo-datetimepicker [id]="'ts_' + selectedObservation.Id + '_interpreted'"
      [(value)]="selectedObservation.ObservationInterpreted"
      (valueChange)="updateObservationInterpreted()"
      [touch]="mobile"
      class="second-column"
      [hideTimeInput]="true"
      [disabled]="!selectedObservation.UpdateObservationInterpretedAllowed"
      datePlaceholder="{{ 'task.observations.observationInterpreted' | blah }}"
      timePlaceholder="{{ 'task.taskTimestamp.timeAbbreviation' | blah }}">
    </hpo-datetimepicker>
  </div>
  <div class="observation-size">
    <span class="title"> {{ 'task.observations.size' | blah}} :</span>
    {{ getSize() || '' }} <span *ngIf="getSize() !== null">m<span class="superscript">2</span></span>
  </div>
  <div class="observation-distanceFromNetwork">
    <span class="title">{{ 'task.observations.distanceFromNetwork' | blah}}: </span>
    <span *ngIf="selectedObservation.DistanceFromNetwork === null">-</span>
    <span *ngIf="selectedObservation.DistanceFromNetwork !== null">{{selectedObservation.DistanceFromNetwork | number:'1.0-1'}} m</span>
  </div>
  <div class="observation-classification">
    <mat-form-field>
      <mat-label>{{ 'task.observations.classification' | blah }}</mat-label>
      <mat-select id="observation-classification-select"
        [value]="selectedObservation.Validity"
        (valueChange)="handleClassificationSelect($event)">
        <mat-option *ngFor="let classification of classifications; let i = index;"
          [value]="classification"
          [id]="'classification-option-'+i">
          {{ 'task.observations.' + classification | blah }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="observation-envelopeContainer">
    <span class="title"> {{ 'task.observations.envelopeCenter' | blah}} (WGS84):</span>
    <div class="observation-envelopeCenter">
      {{selectedObservation.EnvelopeCenterLat | number:'1.6-6':'en-EN'}}, {{selectedObservation.EnvelopeCenterLon | number:'1.6-6':'en-EN'}}
    </div>
  </div>
  <div class="observation-source">
    <span class="title"> {{ 'task.observations.source' | blah}}:</span>
    <div class="observation-envelopeCenter">
      {{selectedObservation.SourceResolution}}
    </div>
  </div>

  <div class="observation-metadataContainer"
    *ngFor="let metadata of selectedObservation.Metadata; let i = index;">
    <span class="title"> {{ 'satnet.metadata.keys.' + metadata.Key | blah }}:</span>
    <div class="observation-metadataValue">
      {{ getMetadataValue(metadata) }}
    </div>
  </div>

</div>

<div *ngIf="mobile"
  class="observation-container-mobile">
  <div *ngIf="selectedObservation">
    <span>
      <div class="observation-identifier-mobile">
        {{ 'task.observations.observations' | blah }} {{ selectedObservation.orderNumber }}:
        <div *ngIf="selectedObservation.Type">
          {{ 'satnet.observationTypes.' + selectedObservation.Type | blah }}
        </div>
      </div>
    </span>
    <div class="observation-size mobile-padding">
      <span class="title"> {{ 'task.observations.size' | blah}}:</span>
      {{ getSize() }} <span *ngIf="getSize() !== null">m<span class="superscript">2</span></span>
    </div>
    <div class="observation-distanceFromNetwork mobile-padding">
      <span class="title"> {{ 'task.observations.distanceFromNetwork' | blah}}: </span>
      <span *ngIf="selectedObservation.DistanceFromNetwork === null">-</span>
      <span *ngIf="selectedObservation.DistanceFromNetwork !== null">{{selectedObservation.DistanceFromNetwork | number:'1.0-1'}} m</span>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'task.observations.classification' | blah }}</mat-label>
        <mat-select id="observation-classification-select"
          class="mobile-padding"
          [value]="selectedObservation.Validity"
          (valueChange)="handleClassificationSelect($event)">
          <mat-option *ngFor="let classification of classifications; let i = index;"
            [value]="classification"
            [id]="'classification-option-'+i">
            {{ 'task.observations.' + classification | blah }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="observation-interpreted observation-interpreted-mobile">
      <hpo-datetimepicker [id]="'ts_' + selectedObservation.Id + '_interpreted'"
        [(value)]="selectedObservation.ObservationInterpreted"
        (valueChange)="updateObservationInterpreted()"
        [touch]="mobile"
        [hideTimeInput]="true"
        [disabled]="!selectedObservation.UpdateObservationInterpretedAllowed"
        datePlaceholder="{{ 'task.observations.observationInterpreted' | blah }}"
        timePlaceholder="{{ 'task.taskTimestamp.timeAbbreviation' | blah }}">
      </hpo-datetimepicker>
    </div>
    <div class="observation-envelopeContainer mobile-padding">
      <span class="title"> {{ 'task.observations.envelopeCenter' | blah}} (WGS84):</span>
      <div class="observation-envelopeCenter">
        {{selectedObservation.EnvelopeCenterLat | number:'1.6-6':'en-EN'}}, {{selectedObservation.EnvelopeCenterLon | number:'1.6-6':'en-EN'}}
      </div>
    </div>

    <div class="observation-metadataContainer mobile-padding"
      *ngFor="let metadata of selectedObservation.Metadata; let i = index;">
      <span class="title"> {{ 'satnet.metadata.keys.' + metadata.Key | blah }}:</span>
      <div class="observation-metadataValue">
        {{ getMetadataValue(metadata) }}
      </div>
    </div>
  </div>
</div>
<br />

<div *ngIf="selectedObservation">
  <div id="imagesContainer"
    class="images-container"
    [ngClass]="{'mobile': mobile}">
    <mat-slide-toggle *ngIf="selectedObservation.Attachments.length > 0"
      [checked]="imageArchiveVisible"
      (toggleChange)="imageArchiveVisibleChanged()">{{ 'task.observations.showArchivedImages' | blah}}</mat-slide-toggle>

    <ng-container *ngFor="let attachment of selectedObservation.Attachments; let i = index;">
      <ng-container *ngIf="imageArchiveVisible || !attachment.Archived">
        <div *ngIf="displayImageHeader(i)"
          class="imageTypeheader"
          [ngClass]="{'mobile': mobile}">{{ getHeaderName(attachment.Type) }}</div>
        <div class="image">
          <div class="padding">
            <span class="title"> {{ 'task.observations.imageTimestamp' | blah}}:</span>
            {{ attachment.Timestamp | date: 'shortDate' }}
          </div>
          <img [id]="'observationImage-' + i"
            class="padding"
            [src]="attachment.ImageUrl">
          <mat-slide-toggle *ngIf="imageArchiveVisible"
            [checked]="attachment.Archived"
            (toggleChange)="imageArchiveStatusChanged(attachment)">{{ 'default.archived' | blah }}</mat-slide-toggle>
        </div>
      </ng-container>
    </ng-container>
  </div>